import { Link } from 'react-router-dom';
import { Banner } from '@immo/ui-kit';
import type { LandIqDataRunRefusalReason, StartLandIqDataRunResponse } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';
import { AlertCircleIcon, WarningTriangleIcon } from '@/components/layout/icons';

type Refusal = Extract<StartLandIqDataRunResponse, { outcome: 'REFUSED' }>;

const DANGER_REFUSALS: ReadonlyArray<LandIqDataRunRefusalReason> = ['RUNNER_UNAVAILABLE', 'UNKNOWN_ENTRY'];

export function StartRefusalBanner({ refusal, entryId }: { readonly refusal: Refusal; readonly entryId: string }) {
  const t = useTranslations('pages.admin.landiq-data-runs');
  const danger = DANGER_REFUSALS.includes(refusal.reason);
  const runningEntry = refusal.reason === 'ALREADY_RUNNING';

  return (
    <Banner
      variant={danger ? 'danger' : 'warning'}
      icon={danger ? <AlertCircleIcon /> : <WarningTriangleIcon />}
      title={t(`refusals.${refusal.reason}`, { entries: refusal.blockedBy.join(', ') })}
      description={
        runningEntry ? (
          <Link className="underline" to={`/landiq/data-runs/${encodeURIComponent(entryId)}`}>
            {t('refusals.to-running-run')}
          </Link>
        ) : undefined
      }
    />
  );
}
